import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogActions, DialogTitle, Grid } from "@material-ui/core";
import { white } from "material-ui/styles/colors";
import OtpInput from "react-otp-input";
import { Button, makeStyles, Typography } from '@material-ui/core';
import MuiLink from "@material-ui/core/Link";
import { withStyles } from '@material-ui/styles';
import { useSelector } from 'react-redux';
import Countdown from "react-countdown-now";
import Alert from "@material-ui/lab/Alert";
import Close from "@material-ui/icons/Close"
import { ticketService } from '../../model/_service';
import { CircularProgress } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const useStyle = makeStyles((theme) => ({
  cancel: {
    color: theme.palette.ePrimary.base,
    marginTop: "0.25rem",
  },
  alertStyle:{
    color:theme.palette.eDanger.dark,
    backgroundColor:theme.palette.eDanger.light,
  },
  submit: {
    backgroundColor: theme.palette.ePrimary.base,
    color: theme.palette.eWhite.base,
    borderRadius: 30,
    '&:hover': {
      backgroundColor: theme.palette.ePrimary.hover,
    },
    padding: "3% 25%",
    marginLeft: "1rem",
    marginRight: "5rem"
  },
  disable: {
    backgroundColor: theme.palette.eLight.base,
    color: theme.palette.eRich.base,
    borderRadius: 30,
    padding: "3% 25%",
    marginLeft: "1rem",
    marginRight: "5rem"
  },
  dialogTitle: {
    color: theme.palette.eWhite.base,
    backgroundColor: theme.palette.ePrimary.base,
  },
  crossButton: {
    color: theme.palette.eWhite.base,
    position: 'absolute',
    right: 8,
    top: 15
  },
  alertIcon: {
    color: theme?.palette?.eTertiary?.base,
    width: "4rem",
    height: "auto",
    display: "block",
    margin: "1rem auto",

  },
  yes: {
    backgroundColor: theme.palette.ePrimary.base,
    color: theme.palette.eWhite.base,
    borderRadius: 30,
    "&:hover": {
      backgroundColor: theme.palette.ePrimary.hover,
    },
    padding: "3% 15%",
    whiteSpace:"nowrap"
  },
  disableButton: {
    "& .Mui-disabled": {
      backgroundColor: theme?.palette?.eLight?.base,
      color: white,
    }
  },
  no: {
    color: theme.palette.ePrimary.base,
  },
  textCenter: {
    textAlign: "center",
  },
  dialoagActionPadding: {
    paddingTop: "0.938rem",
    paddingBottom: "0.938rem",
  },
  cancelPadding: {
    paddingLeft: "4%",
    textAlign:"center"
  },
  circularLoading:{
    color : theme.palette.eWhite.base
  },
  resendLoaderColor:{
    color : theme.palette.ePrimary.base
  },
  otpCustomStyle: {
    fontSize: 30,
    width: 36,  
    height: 36,
    margin: 3.7,
    [theme.breakpoints.down("md")]: {
      padding: 0
    },
  }, dialog:{
    position:"relative",
    zIndex:300 +"!important",
    "& .MuiBackdrop-root": {
      backgroundColor: "rgba(0, 0, 0, 0)"
    },
    "& .MuiDialog-paper": {
      [theme.breakpoints.up("sm")]: {
        minWidth: "400px"
      },
    }
   },
}));

const Link = withStyles(()=>({
  root: {
    "&[disabled]": {
      color: "grey",
      cursor: "default",
      "&:hover": {
        textDecoration: "none"
      }
    }
  }
}))(MuiLink);

function OtpVerification({ individual, openOtpVerification, setIsMobileVerified, setOpenOtpVerification, mobile, setMobileVerificationError, setOpenMobileDialog }) {
  const classes = useStyle();
  const {t:content, ready: contentReady} = useTranslation("content-E_APPLICANT_DETAILS_SCREEN");
  const otpCountDown = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.OTP_COUNTDOWN);
  const otpLength = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.OTP_LENGTH);
  const invalidCountNumber = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.NO_OF_INVALID_ATTEMPTS_OTP_FLOW);
  const summaryReviewLabel = useSelector((state) => state?.labels?.data?.getLabels?.E_SUMMARY_REVIEW);
  const applicantLabels = useSelector((state) => state?.labels?.data?.getLabels?.E_APPLICANT_DETAILS);
  const defaultLockDuration = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.LOCK_DURATION)
  const [otp, setOtp] = useState("");
  const [otpRequired, setOtpRequired] = useState(false);
  const [error, setError] = useState(false);
  const [msg, setMsg] = useState("");
  const [countDownStart, setCountDownStart] = useState(false);
  const [btnDisable, setBtnDisable] = useState(true);
  const [countNumber, setCountNumber] = useState(Number(invalidCountNumber));
  const [countdown, setCountdown] = useState();
  const [resendLinkDisable, setResendLinkDisable] = useState(true);
  const [otpnotsend, setOtpnotsend] = useState(false);
  const [otpError, setOtpError] = useState(false);
  const [otpMAxLimitError, setOtpMAxLimitError] = useState(false);
  const [otpErrorMsg, setOtpErrorMsg] = useState("");
  const [otpUserNotFound, setOtpUserNotFound] = useState(false);
  const [loading, setLoading] = useState(false);
  const [resendLoader, setresendLoader] = useState(false)
  const Colon = ':'

  const handleChange = (otp) => {
    setOtpRequired(false);
    setOtpError(false);
    setError(false);
    setOtpnotsend(false);
    setOtp(otp);

    if (otp.length < Number(otpLength)) {
      setBtnDisable(true);
    }
    else if (otp.length == Number(otpLength)) {
      setBtnDisable(false);
    }
  }

  const countDown = ({ minutes,seconds, completed }) => {
    const newAfter = applicantLabels?.E_APPLICANT_OTP_AFTER_SEC.replace("***", minutes+Colon+seconds);
    if (completed) {
      setCountDownStart(false);
      setResendLinkDisable(false);
      return (
        <React.Fragment>
          {countNumber > 1 ? (
            <Typography
              align="center"
              variant="subtitle2"
            >
              {contentReady ? content("E_OTP_NOT_RECEIVE").answer : ""}
            </Typography>
          ) : (
            <span></span>
          )}
        </React.Fragment>
      );
    } else {
      return (
        <Typography
          align="center"
          variant="subtitle2"
        >
          {newAfter}
        </Typography>
      );
    }
  };

  useEffect(() => {
    if (openOtpVerification) {
      setCountdown(Date.now() + 1000 * Number(otpCountDown));
      setCountDownStart(true);
    }
  }, [openOtpVerification])

  const handleSubmit = (e) => {
    setLoading(true)
    e.preventDefault();
    const otplocal = otp;
    setOtpnotsend(false);
    setOtpMAxLimitError(false);
    setOtpUserNotFound(false);
    setError(false);
    setOtpError(false)
    if (otplocal && otplocal.length === Number(otpLength)) {
      if (mobile) {
        ticketService.velidateOtp(otp, mobile)
          .then((response) => {
            setLoading(false)
            setIsMobileVerified(true);
            setMobileVerificationError(false);
            setOpenOtpVerification(false);
            setOtp("");
            setOpenMobileDialog(false);
          })
          .catch((error) => {
            setLoading(false)
            setBtnDisable(true)
            if (error.response.status === 500) {
              setOtpnotsend(true);
            } else if (error.response.status === 403) {
              setOtpMAxLimitError(true);
              isNaN(error.response.data.message) ?
                setOtpErrorMsg(defaultLockDuration) :
                setOtpErrorMsg(error.response.data.message)
            } else if (error.response.status === 404) {
              setOtpUserNotFound(true);
            } else {
              setError(true);
              setMsg(error.response.data.message);
              setOtpnotsend(false);
            }
          });
      }
    }
  }

  const toResendOTP = () => {
    setresendLoader(true)
    setOtpnotsend(false);
    setOtpMAxLimitError(false);
    setOtpUserNotFound(false);
    setError(false);
    setOtpError(false)
    if (mobile) {
      ticketService.sendOtpMobile(mobile)
        .then((response) => {
          setresendLoader(false)
          setCountdown(Date.now() + 1000 * Number(otpCountDown));
          setOtp("");
          setCountDownStart(true);
          setResendLinkDisable(true);
        })
        .catch((error) => {
          setresendLoader(false)
          if (error.response.status === 500) {
            setOtpnotsend(true);
          } else if (error.response.status === 403) {
            setOtpMAxLimitError(true);
            setOtpErrorMsg(error.response.data.message)
          } else if (error.response.status === 404) {
            setOtpUserNotFound(true);
          } else {
            setOtpError(true);
          }
        });
    }
  }

  const handleCloseOtpVerification = () => {
    setOpenOtpVerification(false);
    setOtp("");
    setOtpnotsend(false);
    setOtpMAxLimitError(false);
    setOtpUserNotFound(false);
    setError(false);
    setOtpError(false)
  }
  const contextMenuHandler = (e) => {
    e.preventDefault();
  }

 const ctrlKeydownHandler = (e) => {
    if (e.ctrlKey) {
      e.preventDefault();
    }
  }
  
  useEffect(()=>{
    if(openOtpVerification){
      window.addEventListener("contextmenu", contextMenuHandler,{capture:true});
      window.addEventListener("keydown", ctrlKeydownHandler,{capture:true});
      return () =>{
        window.removeEventListener("contextmenu", contextMenuHandler,{capture:true});
        window.removeEventListener("keydown", ctrlKeydownHandler,{capture:true});
      } 
    }
  },[openOtpVerification])
  return (
    <Dialog onClose={handleCloseOtpVerification} open={openOtpVerification} disableBackdropClick className={classes.dialog}>
      <DialogTitle className={classes.dialogTitle}>
        <Typography variant="subtitle1">
          {individual ? applicantLabels?.E_APPLICANT_VERIFY_APPLICANT : applicantLabels?.E_APPLICANT_VERIFY_COMPANY}
        </Typography><Button startIcon={<Close />} onClick={handleCloseOtpVerification} className={classes.crossButton}></Button>
      </DialogTitle>
      <DialogContent dividers className={classes.textCenter}>
        <Typography gutterBottom>
          {contentReady ? content("E_VERIFY_SIX_DIGIT_CODE").answer : ""}
        </Typography>
        <Grid container justify='space-around'>
          <OtpInput
            onChange={handleChange}
            numInputs={Number(otpLength)}
            separator={<span></span>}
            shouldAutoFocus={true}
            value={otp}
            isInputNum={true}
            inputStyle={classes.otpCustomStyle}
            containerStyle={{
              margin: "20px auto",
              padding: 10,
              justifyContent: "center"
            }}
          />
        </Grid>
        <Typography gutterBottom>
          {contentReady ? content("E_DONT_RECEIVE_CODE").answer : ""}<br />
          <Link
            component="button"
            disabled={resendLinkDisable}
            underline="always"
            onClick={toResendOTP}
          >
            {applicantLabels?.E_APPLICANT_RESEND} { resendLoader && <CircularProgress className={classes.resendLoaderColor} size={12}/>}
          </Link>
          {countDownStart && (
            <Countdown
              date={countdown}
              renderer={countDown}
            />
          )}

          {otpMAxLimitError &&
            <Alert severity="error" className={classes.alertStyle}>{contentReady ? content("E_MAX_OTP_ATTEMPTS_ERROR").answer?.replace("****", otpErrorMsg) : ""}</Alert>
          }
          {otpError && <Alert severity="error" className={classes.alertStyle}>{contentReady ? content("E_OTP_TRY_AGAIN_ERROR").answer : ""}</Alert>}

          {error === true && (
            <Alert severity="error" className={classes.alertStyle}>{contentReady ? content("E_INVALID_OTP").answer:""}{msg.split(",")[1]}</Alert>
          )}
          {otpnotsend === true && (
            <Alert severity="error" className={classes.alertStyle}>{contentReady ? content("E_OTP_TRY_AGAIN_ERROR").answer:""}</Alert>
          )}
          {otpUserNotFound && <Alert severity="error" className={classes.alertStyle}>{contentReady ? content("E_MAX_OTP_ATTEMPTS_ERROR").answer?.split(".")[0]:""}</Alert>}
        </Typography>
      </DialogContent>
      <DialogActions className={classes.dialoagActionPadding}>
        <Grid item xs={3} sm={2} className={classes.cancelPadding}>
          <Link component="button" onClick={handleCloseOtpVerification} underline="hover" className={classes.no}>
            <Typography  >{summaryReviewLabel?.E_CANCEL_LABEL}</Typography>
          </Link>
        </Grid>
        <Grid item xs={4} sm={3} className={classes.disableButton}>
          <Button
            className={classes.yes}
            size="small"
            align="right"
            onClick={handleSubmit}
            disabled={btnDisable}
          >
            <Typography variant="button">{summaryReviewLabel?.E_SUBMIT_LABEL} { loading && <CircularProgress className={classes.circularLoading} size={12}/>}</Typography>
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
  )
}

export default OtpVerification;